import React from "react";
import AdminLayout from "../components/AdminLayout";
import DashboardHome from "../components/admin/DashboardHome";
import Customers from "../components/admin/Customers";
import Payments from "../components/admin/Payments";
import Budget from "../components/admin/Budget";
import Plans from "../components/admin/Plans";
import Loss from "../components/admin/Loss";
import Tokens from "../components/admin/Tokens";
import CashbackAnalytics from "../components/admin/CashbackAnalytics";
import Wallets from "../components/admin/Wallets";
import Fraud from "../components/admin/Fraud";
import Reports from "../components/admin/Reports";
import Notifications from "../components/admin/Notifications";
import Referrals from "../components/admin/Referrals";
import LuckyDraws from "../components/admin/LuckyDraws";
import SiteSettings from "../components/admin/SiteSettings";
import ContactMessages from "../components/admin/ContactMessages";
import Profile from "../components/admin/Profile";
import InlineTabs from "../components/admin/InlineTabs";
import { useAdminData } from "../hooks/useAdminData";

export default function AdminDashboard() {
  const d = useAdminData();
  const { tab, isSuper, loadAll } = d;

  return (
    <AdminLayout active={tab} onNav={d.setTab}>
      {tab === "dashboard" && <DashboardHome onSettle={loadAll} />}
      {tab === "customers" && <Customers />}
      {tab === "payments" && <Payments />}
      {tab === "budget" && <Budget />}
      {tab === "wallets" && <Wallets />}
      {tab === "tokens" && <Tokens />}
      {tab === "cashback" && <CashbackAnalytics />}
      {tab === "loss" && <Loss />}
      {tab === "fraud" && <Fraud />}
      {tab === "reports" && <Reports />}
      {tab === "referrals" && <Referrals />}
      {tab === "draws" && <LuckyDraws />}
      {tab === "notifications" && <Notifications />}
      {tab === "messages" && <ContactMessages />}
      {tab === "sitesettings" && isSuper && <SiteSettings />}
      {tab === "profile" && <Profile />}
      {tab === "plans" && isSuper && <Plans />}

      <InlineTabs d={d} />
    </AdminLayout>
  );
}
